import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import Button from '@mui/material/Button';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LoginIcon from '@mui/icons-material/Login';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from "../../images/sunrise-logo.png";
import HomeIcon from '@mui/icons-material/Home';
import './Header.css'
import { UserAuth } from "../../AuthContext/AuthContext";
import { Box } from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';

export const Header2 = () => {
    const [currentUrl, setCurrentUrl] = useState(window.location.href);
    const [navbarOptions, setNavbarOptions] = useState([]);
    useEffect(() => {
        if (currentUrl.endsWith("chiefinvestigators") || currentUrl.endsWith("getinvolved") || currentUrl.endsWith("updates") || currentUrl.endsWith("publications") || currentUrl.endsWith("things_to_know")) {
            // console.log(currentUrl);
        } else if (currentUrl.endsWith("login") || currentUrl.endsWith("signup")) {
            setNavbarOptions([
                { name: "Home", link: "#" },
                { name: "About", link: "#" }
            ]);
        } else if (currentUrl.endsWith("memberaccess")) {
            setNavbarOptions([
                { name: "Home", link: "#" }
            ]);
        } else {
            setNavbarOptions([
                { name: "About", link: "#about" },
                { name: "Team", link: "#meetteam" },
                { name: "Countries", link: "#countries" },
                { name: "Chief Investigators", link: "chiefinvestigators" },
                { name: "Updates", link: "#universe" },
                { name: "FAQ's", link: "#faq" }
            ]);
        }
    }, [currentUrl]);

    const { user, logout } = UserAuth();
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <AppBar position="fixed" sx={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <a href='#home' className='navbar_links'>
                        <Box sx={{ flexGrow: 0, display: 'flex' }}>
                            <Link smooth to="/#home">
                                <img src={logo} style={{ paddingTop: '5%', marginBottom: '5%' }} height="105px" width="260px" alt="Sunrise" />
                            </Link>
                        </Box>
                    </a>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none', justifyContent: 'flex-end' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {navbarOptions.length === 6 ?
                                <>
                                    {navbarOptions.map(option => (
                                        <a href={option.link} className='navbar_links' >
                                            <MenuItem
                                                key={option.id}
                                                onClick={handleCloseNavMenu}
                                                style={{ minHeight: '0px', padding: '5px 0px 5px 0px', justifyContent: 'center' }}
                                            >
                                                <Typography textAlign="center" sx={{ color: 'black' }}><span>{option.name}</span> </Typography>
                                            </MenuItem>
                                        </a>
                                    ))}
                                    {user?.email ?
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Link to={'/memberaccess'} style={{ display: 'flex', textDecoration:'none' }}>
                                                <Button variant="contained" className="loginicon" color="warning" style={{ margin: '0px 5px 5px 5px' }}>
                                                    <DashboardIcon fontSize="small" sx={{ mr: '5px' }} />Dashboard
                                                </Button>
                                            </Link>
                                            <Button variant="contained" className="loginicon" color="error" onClick={logout} style={{ marginTop: '7px', padding: '5px 0px 5px 0px', margin: '5px' }}>
                                                <LogoutIcon fontSize="small" sx={{ mr: '5px' }} />Logout
                                            </Button>
                                        </div>
                                        :
                                        <Link to={'/login'} style={{ display: 'flex', textDecoration:'none' }}>
                                            <Button variant="contained" className="loginicon" color="success" style={{ margin: '0px 5px 5px 5px' }}>
                                                <LoginIcon fontSize="small" sx={{ mr: '5px' }} />Log In
                                            </Button>
                                        </Link>
                                    }
                                </>
                                : navbarOptions.length === 1 ?
                                    <>
                                        {user?.email ?
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                    <Button variant="contained" className="loginicon" color="info" style={{ margin: '0px 5px 5px 5px' }}>
                                                        <HomeIcon fontSize="small" sx={{ mr: '5px' }} />Home
                                                    </Button>
                                                </Link>
                                                <Button variant="contained" className="loginicon" color="error" onClick={logout} style={{ marginTop: '7px', margin: '5px 5px 0px 5px' }}>
                                                    <LogoutIcon fontSize="medium" sx={{ mr: '5px' }} />Logout
                                                </Button>
                                            </div>
                                            :
                                            <></>
                                        }
                                    </>
                                    : navbarOptions.length === 2 ?
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <a href="https://www.youtube.com/channel/UCUgmfAGHO1qW7HV73vDVSLw" target="_blank" rel="noreferrer">
                                                <YouTubeIcon style={{ color: 'rgb(233, 49, 49)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                            </a>
                                            <a href="https://twitter.com/StudySunrise" target="_blank" rel="noreferrer">
                                                <TwitterIcon style={{ color: 'rgb(49, 168, 232)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                            </a>
                                            <a href="https://www.instagram.com/_sunrise.study/" target="_blank" rel="noreferrer">
                                                <InstagramIcon style={{ color: 'rgb(243, 119, 42)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                            </a>
                                        </div>
                                        :
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>

                                            {user?.email ?
                                                <>
                                                    <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="info" style={{ margin: '0px 5px 5px 5px' }}>
                                                            <HomeIcon fontSize="small" sx={{ mr: '5px' }} />Home
                                                        </Button>
                                                    </Link>
                                                    <Link to={'/memberaccess'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="warning" style={{ marginTop: '7px', margin: '5px 5px 0px 5px' }}>
                                                            <DashboardIcon fontSize="small" sx={{ mr: '5px' }} />Dashboard
                                                        </Button>
                                                    </Link>
                                                </>
                                                :
                                                <>
                                                    <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="info" style={{ margin: '0px 5px 5px 5px' }}>
                                                            <HomeIcon fontSize="small" sx={{ mr: '5px' }} />Home
                                                        </Button>
                                                    </Link>
                                                    <Link to={'/login'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="success" style={{ marginTop: '7px', margin: '5px 5px 0px 5px' }}>
                                                            <LoginIcon fontSize="small" sx={{ mr: '5px' }} />Log In
                                                        </Button>
                                                    </Link>
                                                </>
                                            }
                                        </div>
                            }
                        </Menu>
                    </Box>

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', justifyContent: 'flex-end' } }}>
                        {navbarOptions.length === 6 ?
                            <>
                                {navbarOptions.map(option => (
                                    <a href={option.link} className='navbar_links' data-offset="200">
                                        <Button
                                            className="NavButton"
                                            key={option.id}
                                            onClick={handleCloseNavMenu}
                                            sx={{ my: 3, color: 'white', display: 'block', textTransform: 'none' }}
                                        >
                                            <span style={{ fontSize: '17px', letterSpacing: '1.5px' }}>{option.name}</span>
                                        </Button>
                                    </a>
                                ))}
                                {user?.email ?
                                    <div style={{ display: 'flex', alignSelf: 'center',flexDirection: 'column' }}>
                                        <Link to={'/memberaccess'} style={{ display: 'flex',textDecoration:'none' }}>
                                            <Button variant="contained" className="loginicon" color="warning">
                                                <DashboardIcon fontSize="small" sx={{ mr: '5px' }} />Dashboard
                                            </Button>
                                        </Link>
                                        <Button variant="contained" className="loginicon" color="error" onClick={logout} style={{ marginTop: '5px' }}>
                                            <LogoutIcon fontSize="small" sx={{ mr: '5px' }} />Logout
                                        </Button>
                                    </div>
                                    :
                                    <div style={{ display: 'flex', alignSelf: 'center' }}>
                                        <Link to={'/login'} style={{ display: 'flex',textDecoration:'none' }}>
                                            <Button variant="contained" className="loginicon_hor" color="success">
                                                <LoginIcon fontSize="small" sx={{ mr: '5px' }} />Log In
                                            </Button>
                                        </Link>
                                    </div>
                                }
                            </>
                            : navbarOptions.length === 1 ?
                                <>
                                    {user?.email ?
                                        <div style={{ display: 'flex', alignSelf: 'center' }}>
                                            <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                <Button variant="contained" className="loginicon" color="info" >
                                                    <HomeIcon fontSize="medium" sx={{ mr: '5px' }} ></HomeIcon>Home
                                                </Button>
                                            </Link>
                                            <Button variant="contained" className="loginicon" color="error" onClick={logout} style={{ marginLeft: '20px' }}>
                                                <LogoutIcon fontSize="medium" sx={{ mr: '5px' }} />Logout
                                            </Button>
                                        </div>
                                        :
                                        <></>
                                    }
                                </>
                                : navbarOptions.length === 2 ?
                                    <div style={{ display: 'flex', alignSelf: 'center' }}>
                                        <a href="https://www.youtube.com/channel/UCUgmfAGHO1qW7HV73vDVSLw" target="_blank" rel="noreferrer">
                                            <YouTubeIcon style={{ color: 'rgb(233, 49, 49)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                        </a>
                                        <a href="https://twitter.com/StudySunrise" target="_blank" rel="noreferrer">
                                            <TwitterIcon style={{ color: 'rgb(49, 168, 232)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                        </a>
                                        <a href="https://www.instagram.com/_sunrise.study/" target="_blank" rel="noreferrer">
                                            <InstagramIcon style={{ color: 'rgb(243, 119, 42)', marginTop: '1rem', height: '50px', width: '80px' }} />
                                        </a>
                                    </div>
                                    :
                                    <>
                                        <>
                                            {user?.email ?
                                                <div style={{ display: 'flex', alignSelf: 'center' }}>
                                                    <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="info" >
                                                            <HomeIcon fontSize="medium" sx={{ mr: '5px' }} ></HomeIcon>Home
                                                        </Button>
                                                    </Link>
                                                    <Link to={'/memberaccess'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="warning" style={{ marginLeft: '20px' }}>
                                                            <DashboardIcon fontSize="small" sx={{ mr: '5px' }} />Dashboard
                                                        </Button>
                                                    </Link>
                                                </div>
                                                :
                                                <div style={{ display: 'flex', alignSelf: 'center' }}>
                                                    <Link to={'/'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon" color="info" >
                                                            <HomeIcon fontSize="medium" sx={{ mr: '5px' }} ></HomeIcon>Home
                                                        </Button>
                                                    </Link>
                                                    <Link to={'/login'} style={{ display: 'flex',textDecoration:'none' }}>
                                                        <Button variant="contained" className="loginicon_hor" color="success" style={{ marginLeft: '20px' }}>
                                                            <LoginIcon fontSize="small" sx={{ mr: '5px' }} />Log In
                                                        </Button>
                                                    </Link>
                                                </div>
                                            }
                                        </>

                                    </>
                        }
                    </Box>

                </Toolbar>
            </Container>
        </AppBar>
    );
}
